<template>
	<div class="pa-6">
		<v-card>
			<v-card-title>
				Почта
				<v-spacer></v-spacer>
			</v-card-title>

			<a-data-table
				:headers="headers"
				api-path="logs/get_mail"
				disable-sort
			>
				<template v-slot:item.time="{ item }">
					{{ item.timeFormatted }}
				</template>
				<template v-slot:item.success="{ item }">
					<v-icon v-if="+item.success" color="green">
						fiber_manual_record
					</v-icon>
					<v-icon v-else color="red">
						fiber_manual_record
					</v-icon>
				</template>
			</a-data-table>
		</v-card>
	</div>
</template>

<style scoped>
</style>

<script>
	import aDataTable from '../base/ADataTable.vue'

	export default {
		components: {
			aDataTable
		},
		data: () => ({
			headers: [
				{
					text: 'Время',
					value: 'time',
					align: 'center',
					noWrap: true,
					filterable: true,
					filterType: 'dateTime',
				},
				{
					text: 'Пользователь',
					value: 'userName',
					align: 'center',
					noWrap: true,
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Получатели',
					value: 'recipients',
					align: 'center',
					filterable: true,
					filterType: 'text',
				},
				{
					text: 'Тема',
					value: 'subject',
					align: 'center',
					filterable: true,
					filterType: 'text',
				},
				{
					text: 'Успех',
					value: 'success',
					align: 'center',
					filterable: true,
					filterType: 'boolean',
				},
			],
		}),
		methods: {

		}
	}
</script>
